import { sseControllerGetEventsHistory } from '@/api/events/events'
import { SseControllerGetEventsHistoryEventTypesItem, SseEventDto } from '@/api/model'

// Events that we want to track for live activities
const LIVE_ACTIVITY_EVENTS: SseControllerGetEventsHistoryEventTypesItem[] = [
  SseControllerGetEventsHistoryEventTypesItem.dreamgoal_reached,
  SseControllerGetEventsHistoryEventTypesItem.dreamapproved,
  SseControllerGetEventsHistoryEventTypesItem.donationconfirmed,
  SseControllerGetEventsHistoryEventTypesItem.dreamunfrozen,
]

/**
 * Fetch recent live activity events from history
 * @param limit Number of events to fetch (default: 5, max: 50)
 * @returns Promise with array of SSE events
 */
export async function fetchLiveActivitiesHistory(
  limit: number = 5,
): Promise<SseEventDto[]> {
  try {
    const response = await sseControllerGetEventsHistory({
      eventTypes: LIVE_ACTIVITY_EVENTS,
      scope: 'lobby',
      limit: Math.min(limit, 5),
    })

    return response.events || []
  } catch (error) {
    console.error('Failed to fetch live activities history:', error)
    return []
  }
}
